import React from "react";
import PropTypes from "prop-types";

import styles from "./legend.module.scss";

const Legend = ({ data = [], title = "", className = "" }: { data: any[], title: string, className: string }) => {
  return (
    <div className={className}>
      {title && <div className={styles.Title}>{title}</div>}
      <ul className={styles.chartlegend}>
        {data.map((item: any, i: any) => (
          <React.Fragment key={item.name + i}>
            <li key={item.name + i} id={`legend_${item.name}_${i}`}>
              <span
                id={`legend_${item.name}_${i}_Color`}
                className={`
                     ${styles.marker} 
                     ${item.rounded}`}
                style={{ backgroundColor: item?.color }}
              ></span>
              <span id={`legend_${item.name}_${i}_txt`}>{item?.name}</span>
            </li>
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};

Legend.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  rounded: PropTypes.bool
};

export default Legend;
